module.exports = __webpack_public_path__ + "static/img/305_TO8_2287_og.1b3e90f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/305_TO8_2287_og.jpg
// module id = 3xj/
// module chunks = 0